import React from 'react'
// components
import AccountsContainer from 'containers/Accounts'

const AccountsPage: React.FC = () => <AccountsContainer />

export default AccountsPage
